const pagesIndividualCertificationsEn = {
  headers: {
    certificationKind: 'Kind',
    expireAt: 'Valid until',
    lastUpdated: 'Last renewed',
    name: 'Certification',
    number: 'Certificate No.',
    renewBy: 'Renewal deadline'
  },
  pageTitle: 'Certifications',
  tabs: {
    self: 'My certifications'
  }
};
export default pagesIndividualCertificationsEn;